import { Container } from "@chakra-ui/react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/student/Layout/layout";
import Teachers from "../../../containers/student/home/teachers";
import { getAllTeachersRequest } from "../../../modules/public/publicData/Actions";

const TeashersList = () => {
  const { isLoading } = useSelector((state) => state.public);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllTeachersRequest());
  }, []);
  return (
    <Layout color="main_1" bg="white" isLoading={isLoading}>
      <Container 
        maxW="container.2xl" 
        h="100%" 
        my={{ base: "60px", md: "80px", lg: "100px" }} 
        mb={{ base: "100px", md: "130px", lg: "165px" }} 
        w="100%"
        px={{ base: 4, md: 6, lg: 8 }}
      >
        <Teachers link="/student/teacher" />
      </Container>
    </Layout>
  );
};

export default TeashersList;
